import React, { Component } from 'react';
import * as styled from './row.styled';
import $ from 'jquery';
import Cell from '../cell/cell';

class Row extends Component {

    constructor(props) {
        super(props);
        this.row = React.createRef();
        this.cells = [];
        this.animTry = 0;
        this.animPercent = -100;
        this.animating = false;
        if (props.data.anims) for (let index = 0; index < props.data.anims.length; index++)
            this.cells[index] = React.createRef();
        this.state = {
            renderCells: true
        };
        this.onScrollHandler = (() => {
            this.calcul();
        }).bind(this);
        this.onOrientationChangeHandler = (() => {
            window.setTimeout(this.updateSelf.bind(this), 250);
        }).bind(this);
        this.onResizeHandler = (() => {
            window.setTimeout(this.updateSelf.bind(this), 250);
        }).bind(this);
    }

    componentDidCatch(){}

    componentDidMount() {
        this.mounted = true;
        $(document).on('scroll', this.onScrollHandler);
        $(window).on('orientationchange', this.onOrientationChangeHandler);
        $(window).on('resize', this.onResizeHandler);
    }

    componentWillUnmount() {
        this.mounted = false;
        $(document).unbind('scroll', this.onScrollHandler);
        $(window).unbind('orientationchange', this.onOrientationChangeHandler);
        $(window).unbind('resize', this.onResizeHandler);
    }

    updateSelf() {
        if (this.mounted) this.forceUpdate(this.calcul.bind(this));
    }

    calcul() {
        /*if (!this.state.renderCells && percent > -200) {
                this.setState((state) => {
                    return {...state, renderCells: true};
                });
            }*/
            //if (!this.animating) {
                let percent = this.getScrollPercent();
            //    this.anim(percent);
            //}
            //if (percent > -150 && percent < 250) {
                this.cells.map((cell) => {
                    if (!cell || !cell.current) return;
                    cell.current.setScrollerPercent(percent);
                });
            //}
    }

    anim(percent) {
        this.animating = true;
            
        percent = percent || this.getScrollPercent();
        for(var i = 0; i < this.cells.length; i++) {
            window.requestAnimationFrame(((i) => {
                if (this.cells[i]) {
                    this.cells[i].current.setScrollerPercent(percent);
                }
            }).bind(this, i));
        }

        if (this.animTry < 10) {
            this.animTry++
            window.requestAnimationFrame(this.anim.bind(this));
        } else {
            this.animTry = 0;
            this.animating = false;
        }

        /*
        this.cells.map((cell) => {
            if (!cell) return;
            cell.current.setScrollerPercent(percent);
        });
        if (Math.ceil(this.animPercent) !== Math.ceil(percent)) {
            this.animPercent = percent;
            this.animTry = 0;
            window.requestAnimationFrame(this.anim.bind(this, percent));
        } else {
            if (this.animTry < 10) {
                this.animTry++;
                window.requestAnimationFrame(this.anim.bind(this, percent));
            } else {
                this.animating = false;
            }
        }*/
    }

    height() {
        return this.props.height;
        //return this.props.data.anims.length > 1 && !this.props.isMobileVersion ? window.innerWidth * 0.52 : this.props.height;
    }

    getScrollPercent() {
        if (!this.row.current) return -100;
        let rect = this.row.current.getBoundingClientRect();
        return (rect.top - this.height()) * -1 / this.height() * 100;
    }

    getMargin() {
        let hasScrollCell = false;
        for (var index in this.props.data.anims)
            if (this.props.data.anims[index] && this.props.data.anims[index].type && this.props.data.anims[index].type.indexOf('scroll-from') === 0)
                hasScrollCell = true;
        return this.height() * (hasScrollCell ? 0.1 : 0);
    }

    render() {
        return (
            <styled.Row
                ref={this.row}
                height={this.height()}
                margin={this.getMargin()}
                nbcells={this.cells.length || 1}
                style={{justifyContent: this.props.data.justify}}
                className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                {this.props.data.anims && this.state.renderCells ?
                    this.props.data.anims.map((anim, index) => {
                        return <Cell
                            ref={this.cells[index]}
                            height={this.height() * 0.7}
                            key={`ScrollerCell${index}`}
                            data={anim} parent={this.row}
                            cellIndex={index}
                            totalCells={this.props.data.anims.length}
                            isMobileVersion={this.props.isMobileVersion} />;
                    })
                :null }
            </styled.Row>
        );
    }
}

export default Row;